module.exports = __webpack_public_path__ + "img/cooler_des_1.e7a85a83.jpg";